import { MagnifyingGlassIcon, PlusIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface ActionBarProps {
    onSearchChange: (value: string) => void;
    onFilterChange: (value: string) => void; // kept for compatibility (unused)
    onSortChange: (value: string) => void; // kept for compatibility (unused)
    titleKey: string;
    onAddClick: () => void;
    searchValue: string;
}

const ActionBar: React.FC<ActionBarProps> = ({ onSearchChange, onFilterChange, onSortChange, titleKey, onAddClick, searchValue }) => {
    const [t] = useTranslation('teams');
    // Filter and sort removed per UX request

    return (
        <div>
            <div className="mb-5 flex items-center gap-3">
                {/* Search Bar */}
                <label className="input input-bordered flex w-full max-w-xl items-center gap-2 rounded-full">
                    <MagnifyingGlassIcon className="h-5 w-5 opacity-60" />
                    <input
                        type="text"
                        placeholder={t('search')}
                        value={searchValue}
                        className="w-full grow bg-transparent outline-none"
                        onChange={(e) => onSearchChange(e.target.value)}
                    />
                </label>

                <button
                    className="btn btn-primary btn-sm rounded-full"
                    onClick={onAddClick}
                >
                    <PlusIcon className="h-5 w-5" />
                    {titleKey === 'title_teams' && t('add_team')}
                    {titleKey === 'title_users' && t('add_user')}
                    {titleKey === 'title_rolPermissions' && t('add_role_permission')}
                    {titleKey === 'title_tags' && t('add_tag')}
                    {titleKey === 'title_profile_settings' && t('add_profile_variable')}
                </button>
            </div>
        </div>
    );
};

export default ActionBar;
